import * as AuthenticationActionTypes from './constants';

function safeParse(value) {
  if (!value || value === 'undefined') return null;
  try {
    return JSON.parse(value);
  } catch (e) {
    console.warn('Failed to parse localStorage value:', value, e);
    return null;
  }
}


const storedUser = window.localStorage.getItem('user');
const storedLoginTime = window.localStorage.getItem('loginTime');
const storedCollaborators = window.localStorage.getItem('collaborators');
const storedCollaboratingCauses = window.localStorage.getItem('collaboratingCauses');

const initialState = {
  user: safeParse(storedUser),
  loginTime: storedLoginTime && storedLoginTime !== 'undefined' ? storedLoginTime : null,
  collaborators: safeParse(storedCollaborators),
  collaboratingCauses: safeParse(storedCollaboratingCauses),
  activityLogs: [],
  causeDetails: null,
  identity: null,
};

const actionsMap = {
  [AuthenticationActionTypes.SET_USER](state, { payload }) {
    const {
      user, loginTime, collaborators, collaboratingCauses,   
    } = payload;
    return {
      ...state,
      user,
      loginTime,
      collaborators,
      collaboratingCauses,
    };
  },
  [AuthenticationActionTypes.SET_ROUNDUPS_VISIBILITY](state, action) {
    return {
      ...state,
      user: {
        ...state.user,
        roundups_visible: action.payload,
      },
    };
  },
  [AuthenticationActionTypes.SET_CONTRIBUTE_NOW_VISIBILITY](state, action) {
    return {
      ...state,
      user: {
        ...state.user,
        contribute_now_visible: action.payload,
      },
    };
  },
  [AuthenticationActionTypes.SET_USER_IDENTITY](state, action) {
    return {
      ...state,
      identity: action.payload,
    };
  },
  [AuthenticationActionTypes.SET_USER_PROFILE](state, action) {
    return {
      ...state,
      user: action.payload,
    };
  },
  [AuthenticationActionTypes.UNSET_USER](state) {
    return {
      ...state,
      user: null,
      loginTime: null,
      collaborators: null,
      collaboratingCauses: null,
      activityLogs: [],
      causeDetails: null,
      identity: null,

    };
  },
  [AuthenticationActionTypes.SET_CAUSE_DETAILS](state, action) {
    return {
      ...state,
      causeDetails: action.payload,
    };
  },
  [AuthenticationActionTypes.SET_ACTIVITY_LOGS](state, action) {
    return {
      ...state,
      activityLogs: action.payload,
    };
  },

};

export default function authentication(state = initialState, action) {
  console.log(['AUTH reducer initiated with action: ' , action]);
  console.log(['AUTH reducer about to update state currently: ', state ]);
  const reduceFn = actionsMap[action.type];
  if (!reduceFn) {
      console.log ('NO ACTION FOUND FOR AUTH REDUCER. ACTION was : ', action);
    return state;
  }
  return reduceFn(state, action);
}
